export default function WhyMentalism() {
  return (
    <section className="relative py-32 px-6 bg-zinc-950">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative h-[600px] w-full rounded-2xl overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/eccac6198779c2f7616d168824d01e86.png"
                alt="Why Mentalism for Business"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent opacity-40"></div>
            </div>
            
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-red-600/10 rounded-2xl -z-10"></div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Why Mentalism<br />
              <span className="bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
                for Events?
              </span>
            </h2>
            
            <div className="space-y-6 mb-8">
              <p className="text-gray-300 text-base leading-relaxed">
                Using psychological illusion and body language, I deliver experiences that boost engagement. &nbsp;Every performance is tailored to align with your values and event goals.
              </p>
              
              <p className="text-gray-300 text-base leading-relaxed">
                Mentalism creates shared moments of wonder that break down barriers and foster genuine connections. It's not just entertainment—it's a catalyst for conversation, collaboration, and memorable experiences that extend far beyond the event itself.
              </p>
            </div>

            {/* Key Benefits */}
            <div className="space-y-4">
              <div className="flex items-start gap-4 p-4 bg-zinc-900 rounded-lg border border-zinc-800">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-red-600/10 flex-shrink-0">
                  <i className="ri-lightbulb-line text-xl text-red-500"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Boost Engagement</h4>
                  <p className="text-gray-400 text-sm">Interactive experiences that captivate and energize your audience</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-zinc-900 rounded-lg border border-zinc-800">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-red-600/10 flex-shrink-0">
                  <i className="ri-links-line text-xl text-red-500"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Foster Networking</h4>
                  <p className="text-gray-400 text-sm">Natural ice-breakers that spark genuine conversations</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-zinc-900 rounded-lg border border-zinc-800">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-red-600/10 flex-shrink-0">
                  <i className="ri-star-line text-xl text-red-500"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Tailored to Your Brand</h4>
                  <p className="text-gray-400 text-sm">Customized performances that reflect your corporate values</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}